import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import FocusLock from 'react-focus-lock';

import MenuBtn from '@components/MenuBtn';

import style from '../index.module.scss';
import OffCanvasMenu from '../OffCanvasMenu';
import MenuActionsDefault from '../Actions';
import { VERSION_LITE, MENU_OFFCANVAS } from '@lib/constants';

export default function DefaultMenu({ isAdvisorView = false }) {
	const [menuState, setMenuState] = useState(false);
	const menuRef = useRef(null);
	const [isMobile, setIsMobile] = useState(false);

	const setMenuToggleState = (currentState) => {
		setMenuState(currentState);
	};

	const shouldShowMenu = MENU_OFFCANVAS || isMobile;

	useEffect(() => {
		const masthead = document.querySelector('.masthead');

		const checkIsMobile = () => setIsMobile(window.innerWidth < 900);
		checkIsMobile();
		window.addEventListener('resize', checkIsMobile);

		function handleClickOutside(event) {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setMenuState(false);
			}
		}

		if (menuState) {
			document.body.classList.add('no-overflow');
			masthead?.classList.add('menuOpen');

			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.body.classList.remove('no-overflow');
			masthead?.classList.remove('menuOpen');

			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.body.classList.remove('no-overflow');
			masthead?.classList.remove('menuOpen');
			document.removeEventListener('mousedown', handleClickOutside);
			window.removeEventListener('resize', checkIsMobile);
		};
	}, [menuState]);

	if (VERSION_LITE) {
		return;
	}

	return (
		<>
			<div
				ref={menuRef}
				className={`${style.nonSticky} ${style.menuRight} ${MENU_OFFCANVAS && style.offCanvas} ${menuState && style.isOpen} menuRight masthead__right`}
			>
				<div className={`defaultActions`}>
					<MenuActionsDefault toggleMenuState={setMenuToggleState} isAdvisorView={isAdvisorView} />
				</div>

				{shouldShowMenu &&
					(menuState ? (
						<FocusLock>
							<MenuBtn currentMenuState={menuState} menuState={(e) => setMenuToggleState(e)} />

							<div
								className={`${style.additionalContainer} ${style.desktopOffCanvas} offCanvasMenuContainer`}
							>
								<OffCanvasMenu />
							</div>
						</FocusLock>
					) : (
						<>
							<MenuBtn currentMenuState={menuState} menuState={(e) => setMenuToggleState(e)} />

							<div
								className={`${style.additionalContainer} ${style.desktopOffCanvas} offCanvasMenuContainer`}
							>
								<OffCanvasMenu />
							</div>
						</>
					))}
			</div>
		</>
	);
}
